import React from 'react';
import { Section, Typography } from 'common/components';
import { createElementKey } from 'utils';
import { ADPLATFORM_TRAINING_WEBINARS_DATA } from './adplatform-training-webinar-section-constants';
import { adplatformTrainingWebinarSectionTitle } from './adplatform-training-webinar-section-styles';
import { AdplatformTrainingWebinarItem } from './components';

export const AdplatformTrainingWebinarSection: React.FC = () => (
  <Section>
    <Typography className={adplatformTrainingWebinarSectionTitle} as="h2" variant="h2">
      Больше знаний&nbsp;&mdash; больше продаж
    </Typography>

    {ADPLATFORM_TRAINING_WEBINARS_DATA.map((webinar, index) => (
      <AdplatformTrainingWebinarItem key={createElementKey('webinar', index)} webinarStructure={webinar} />
    ))}
  </Section>
);
